export * from './pipes.module';
export * from './initials.pipe';
export * from './phone-number-format.pipe';
export * from './date-format.pipe';
export * from './group-digits.pipe';
export * from './currency.pipe';
